import { BarChart2, Table } from "lucide-react";
import { Loading } from "../loading/loading";

export function ChartCard({ title, view, onViewChange, children, tableContent, accent, loading }) {
    return (
        <div style={{
            background: C.surface, border: `1px solid ${C.border}`, borderRadius: 14,
            overflow: "hidden", boxShadow: "0 1px 4px rgba(15,23,42,.06)",
        }}>
            <div style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "14px 18px", borderBottom: `1px solid ${C.border}`,
                background: C.surfaceAlt,
            }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {accent && <div style={{ width: 3, height: 16, background: accent, borderRadius: 2 }} />}
                    <h3 style={{ margin: 0, fontSize: 13, fontWeight: 700, color: C.text }}>{title}</h3>
                </div>
                {onViewChange &&
                    <ViewToggle value={view} onChange={onViewChange} />
                }
            </div>

            {loading ?
                <div>
                </div>
                :
                <div style={{ padding: "16px 18px" }}>
                    {view === "chart" ? children : tableContent}
                </div>
            }

        </div>
    );
}

function ViewToggle({ value, onChange }) {
    return (
        <div style={{
            display: "flex", background: C.surfaceAlt, border: `1px solid ${C.border}`,
            borderRadius: 8, padding: 3, gap: 2,
        }}>
            {[{ key: "chart", icon: <BarChart2 size={16} /> }, { key: "table", icon: <Table size={16} /> }].map(({ key, icon, label }) => (
                <button key={key} onClick={() => onChange(key)} style={{
                    padding: "4px 12px", borderRadius: 6, border: "none", fontSize: 12,
                    cursor: "pointer", fontFamily: "var(--font-sans)",
                    background: value === key ? C.surface : "transparent",
                    color: value === key ? C.text : C.muted,
                    fontWeight: value === key ? 600 : 400,
                    boxShadow: value === key ? "0 1px 3px rgba(15,23,42,.1)" : "none",
                    transition: "all .15s",
                }}>
                    {icon}
                </button>
            ))}
        </div>
    );
}

const C = {
    bg: "#F0F4F8",
    surface: "#FFFFFF",
    surfaceAlt: "#F8FAFC",
    border: "#E2E8F0",
    borderStrong: "#CBD5E1",
    primary: "#0EA5E9",
    primaryDark: "#0284C7",
    secondary: "#6366F1",
    accent: "#10B981",
    danger: "#EF4444",
    warn: "#F59E0B",
    purple: "#8B5CF6",
    text: "#0F172A",
    textMid: "#475569",
    muted: "#94A3B8",
    c1: "#0EA5E9",
    c2: "#6366F1",
    c3: "#10B981",
    c4: "#F59E0B",
    c5: "#EF4444",
};
